import {
  TMappedIssueDTO,
  TGenericIssueDTO,
  TSilhouetteOperationOutput,
  TMappedIssueDTOWithType,
  TGenericIssueDTOWithType,
} from '../../ba-app';
import { TRCAHierarchicalResponse } from '@monorepo/types';
export type TREQUEST_masterdataLists = {
  query_name: 'get_all_lists';
  subject_key: string;
  combinations: TCombination[];
};

export type TREQUEST_masterdataListsV2 = {
  factoryId: string;
  departments: string[];
  productTypeStyles: {
    style: string;
    productType: string;
  }[];
};

export type TRESPONSE_masterdataListsV2 = {
  factoryId: string;
  departmentWiseOperationsAndIssues: {
    [department: string]: {
      operationsAndIssues: TOperationIssueResponseDTO[];
      genericIssues: TGenericIssueDTO[];
    };
  };
};

export type TCombination = {
  req_id: string;
  subject_key: string;
  tags: Record<string, string>;
  list_names: string[];
};

export type TMasterdataItemInfo = {
  category_id: string;
  group_id: string[];
  id: string;
  name: string;
  //category and sub_category will be coming for Roaming qc
  category: string;
  sub_category: string;
  group_name: string;
  // TODO: group_name key ===> for correctiveReasons
};

export type TMasterdataListInfo = {
  dis_name: string;
  keyword: string;
  list: TMasterdataItemInfo[];
  name: string;
  tags: string[];
};

export type TRESPONSE_masterdataLists = {
  response: {
    req_id: string;
    data: {
      [key in string]: TMasterdataListInfo;
    };
  }[];
};
export type TSilhouetteItem = {
  name: 'front' | 'back';
  id: string;
};

export type TSilhouetteListInfo = {
  dis_name: string;
};

export type TAllSilhouetteListsByBctx = {
  req_id: string;
  data: {
    silhouette: TSilhouetteListInfo;
  };
};
export type TRESPONSE_silhouetteKeys = {
  response: TAllSilhouetteListsByBctx[];
};

export type TREQUEST_silhouetteKeys = {
  query_name: 'get_all_lists';
  subject_key: string;
  combinations: TCombination[];
};

export type TREQUEST_correctiveReasons = {
  query_name: 'get_classification_list_names_by_list_type';
  subject_key: string;
  l_type: 'corrective_reasons_list';
};

type TCorrectiveReasonsResult = {
  tags: any[];
  list_type: string;
  list_name: string;
  data: TCorrectiveReasonData;
  ms_nm: string;
  ls_nm: string;
  ds_nm: string;
};

type TCorrectiveReasonData = {
  name: string;
  _list: TMasterdataItemInfo[];
};

export type TRESPONSE_correctiveReasons = {
  result: TCorrectiveReasonsResult[];
  // status: 'sucesss'; // TODO: check all possible values
};
export type TAllMasterdataListsByBctx = {
  [key in string]: {
    [data in string]: {
      masterdataList: TMasterdataListInfo;
      filteredMasterdataList: string[];
      lastSyncedAt: number;
    };
  };
};
export type TMasterdataSyncStatus = 'SYNCING' | 'SYNCED' | 'FAILED' | 'INIT';
export type TOperationDTOWithMappedIssuesDTO = {
  id: string;
  name: string;
  department: string;
  issues: TMappedIssueDTO[];
};
export type TOperationDTOWithMappedIssuesAndFilteredIssuesListDTO = TOperationDTOWithMappedIssuesDTO & {
  filteredIssuesList: string[];
};
export type TOperationIssueResponseDTO = {
  productType: string;
  style: string;
  operations: TOperationDTOWithMappedIssuesDTO[];
};

export type TOperationsAndIssuesAndSilhouetteOperations = {
  operations: {
    lastSyncedAt: number;
    filteredOperationsList: string[];
    list: TOperationDTOWithMappedIssuesAndFilteredIssuesListDTO[];
  };
  silhouetteOperations: {
    frontImageOperations: TSilhouetteOperationOutput[];
    backImageOperations: TSilhouetteOperationOutput[];
  };
};
export type TMasterdataListByProductTypeAndStyle = {
  [product_type: string]: {
    [style: string]: TOperationsAndIssuesAndSilhouetteOperations;
  };
};
export type TMasterdataListDB = {
  nextCacheResetTimestamp: number;
  allMasterdataListsByBctx: TAllMasterdataListsByBctx;
  silhouetteKeysInfo: {
    keys: Record<string, string>;
  };
  correctiveReasons: TRESPONSE_correctiveReasons;
  masterdataListV2: {
    [department: string]: {
      genericIssues: {
        list: TGenericIssueDTO[];
        filteredRejectList: string[];
        filteredDefectList: string[];
      };
      listByProductTypeAndStyle: TMasterdataListByProductTypeAndStyle;
    };
  };
  rcaHierarchicalData: TRCAHierarchicalResponse;
};
export type TDefectMarkingLandingInputDTO = {
  style: string;
  productType: string;
  backImageUrl: string;
  frontImageUrl: string;
  silhouetteName: string;
};
export type TMarkedDefect = {
  silhuetteType: 'FRONT' | 'BACK';
  color: string;
  operation: { id: string; name: string; department: string };
  issue: TMappedIssueDTOWithType | TGenericIssueDTOWithType;
  coordinate: [x: number, y: number][];
};

export type TOperationAnsIssueAndSilhouetteImagesResultSuccess = {
  status: 'SUCCESS';
  genericIssues: TGenericIssueDTO[];
  operations: TOperationsAndIssuesAndSilhouetteOperations['operations']['list'];
  silhouetteOperations: TOperationsAndIssuesAndSilhouetteOperations['silhouetteOperations'];
};

export type TAllDepartmentsData = {
  [department: string]: TOperationAnsIssueAndSilhouetteImagesResultSuccess;
};

export type TOperationAndDeptWiseGenericIssue = {
  status: 'SUCCESS';
  genericIssues: {
    [department: string]: {
      list: TGenericIssueDTO[];
      filteredDefectList?: string[];
    };
  };
  operations: TOperationsAndIssuesAndSilhouetteOperations['operations']['list'];
  filteredOperationsList: TOperationsAndIssuesAndSilhouetteOperations['operations']['filteredOperationsList'];
};

export type TDepartmentWiseOperationListAndGenericIssueMap = {
  [department: string]: {
    operationsList: TOperationDTOWithMappedIssuesAndFilteredIssuesListDTO[];
    allOperationList: TOperationDTOWithMappedIssuesAndFilteredIssuesListDTO[];
    genericIssues: {
      list: TGenericIssueDTO[];
      filteredDefectList: string[];
    };
  };
};

export type TDefectSilhoutteData = {
  silhouette_front: string;
  silhouette_back: string;
  silhoutteId: string;
};

export type TOperationAnsIssueAndSilhouetteImagesResult =
  | {
      status: 'FAILURE';
      error: string;
    }
  | TOperationAnsIssueAndSilhouetteImagesResultSuccess;

export type TDepartmentWiseOperationAndGenericIssueResult =
  | {
      status: 'FAILURE';
      error: string;
    }
  | {
      status: 'SUCCESS';
      data: TDepartmentWiseOperationListAndGenericIssueMap;
    };

export type TMasterdataListResult =
  | {
      status: 'FAILURE';
      error: 'NOT_FETCHED' | 'NOT_CONFIGURED';
    }
  | {
      status: 'SUCCESS';
      list: TMasterdataItemInfo[];
      allList: TMasterdataItemInfo[];
    };

export type TMasterdataRejectList =
  | {
      status: 'FAILURE';
      error: 'NOT_FETCHED';
    }
  | {
      status: 'SUCCESS';
      list: TGenericIssueDTO[];
      allList: TGenericIssueDTO[];
    };

export type TSilhouetteKeyResult = {
  status: 'SUCCESS' | 'FAILURE';
  error?: 'NOT_FETCHED' | 'NOT_CONFIGURED';
  silhouetteKey?: string;
  message?: string;
};

export type TAppSyncScreenItem = {
  id?: string;
  name: string;
  type: string;
  value: string;
};

export const CORRECTIVE_ACTIONS_LIST_SYNCING_KEY = 'corrective_actions_list';
export const SILHOUETTES_SYNCING_KEY = 'file';
export const BCTX_SYNCING_KEY = 'ctx';
export const RECTIFIED_LISING_SYNCING_KEY = 'rectified_list';
export const OPERATION_ISSUE_SYNCING_KEY = 'operation_issue_list';
export const RCA_HEIRARCHICAL_DATA_SYNCING_KEY = 'rca_hierarchical_data';
